export default "__VITE_ASSET__xMQUYTjl__"